export default "__VITE_ASSET__a664a627__"